export default {"src":"/_next/static/media/sale.7d9cf7c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};